<template>
  <div
    :class="{
      console: true,
      open
    }"
  >
    <div class="close" @click="open = false">&times;</div>
    <div class="header">Image Console</div>
    <div class="description">
      Change image settings here. <strong>Mode</strong>
      affects how images are stacked (pyramid = center image on top, horizontal
      = rightmost image on top) and whether the images are blended.
      <strong>Blend Margin</strong> determines how much of an image is
      transparent&mdash;10% would make the left and right tenths of an image
      transparent. <strong>Visible area</strong> determines how much of Sunset
      is visible at once. Larger values will squish images together in order to
      show more of Sunset simultaneously, smaller values will show fewer images
      more spaced out.
    </div>
    <div class="control-group">
      <label>mode:</label>
      <select @change="onModeChange()" v-model="mode">
        <option v-for="mode in availableModes" :key="mode">
          {{ mode }}
        </option>
      </select>
    </div>
    <div class="control-group">
      <label>blend margin:</label>
      <div class="input">
        <input
          type="range"
          min="0"
          max="0.4"
          step="0.001"
          @change="onBlendPercentageChange()"
          v-model="blendPercentage"
        />
        <span class="input-value">{{ blendPercentageFormatted }}</span>
      </div>
    </div>
    <div class="control-group">
      <label>visible area:</label>
      <div class="input">
        <input
          type="range"
          min="0.001"
          max="0.2"
          step="0.001"
          @change="onVisibleDistanceChange()"
          v-model="visibleDistance"
        />
        <span class="input-value">{{ visibleDistance }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3";

export default {
  name: "DriveAdminConsole",
  data() {
    return {
      blendPercentage: this.$store.state.imageFlipper.blendPercentage,
      open: false,
      mode: this.$store.state.imageFlipper.mode,
      visibleDistance: this.$store.state.imageFlipper.visibleDistance
    };
  },
  computed: {
    availableModes() {
      return this.$store.state.imageFlipper.availableModes;
    },
    blendPercentageFormatted() {
      return d3.format(".1%")(this.blendPercentage);
    }
  },
  mounted() {
    window.addEventListener("keydown", this.keydown);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.keydown);
  },
  methods: {
    keydown(e) {
      if (process.env.NODE_ENV === "production") return;
      if (e.code === "Slash") {
        this.open = !this.open;
      }
    },
    onBlendPercentageChange() {
      this.$store.dispatch("setBlendPercentage", this.blendPercentage);
    },
    onModeChange() {
      this.$store.dispatch("setImageFlipperMode", this.mode);
    },
    onVisibleDistanceChange() {
      this.$store.dispatch("setVisibleDistance", this.visibleDistance);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/constants/_variables.scss";

.console {
  background: white;
  border: 2px solid $copper;
  display: none;
  flex-direction: column;
  justify-content: space-between;
  padding: 0.5em;
  position: absolute;
  min-height: 100px;
  width: 350px;
  bottom: 25px;
  right: -375px;
  z-index: 1000;
  transition: right 1s;

  &.open {
    display: flex;
    right: 50px;
  }
}

.close {
  cursor: pointer;
  font-size: 1.5em;
  line-height: 0.5em;
  position: absolute;
  right: 1rem;
  top: 1rem;
}

.header {
  margin-bottom: 0.5rem;
  align-self: center;
}

.description {
  font-size: 0.9em;
  margin: 0.5rem 0;
  text-align: left;
}

.control-group {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0.1rem 0;
}

label {
  font-size: 0.9rem;
}

.input {
  display: flex;
  align-items: center;
}

.input-value {
  display: inline-block;
  text-align: right;
  width: 5rem;
}
</style>
